:host {
  .module-avatar {
    &__initial {
      border-radius: 50%;
      background: #f5f5f5;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
    }

    &__logo {
      img {
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        object-fit: contain;
      }
    }
  }
}
